import { Component } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/errorPage.css";

export function ErrorPage() {
  const navigate = useNavigate();

  return (
    <div className="lp-container">
      <div className="lp-card ep-card">

        <div className="ep-icon">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5}
              d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
          </svg>
        </div>

        <h1 className="ep-title">Something went wrong</h1>
        <p className="ep-body">
          An unexpected error occurred. Try reloading the page — if the problem
          persists, return to the home page.
        </p>

        <div className="ep-actions">
          <button className="lp-submit ep-btn-reload" onClick={() => window.location.reload()}>
            Reload page
          </button>
          <button className="ep-btn-home" onClick={() => navigate("/home")}>
            Go to home
          </button>
        </div>

      </div>
    </div>
  );
}

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="lp-container">
          <div className="lp-card ep-card">

            <div className="ep-icon">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5}
                  d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
              </svg>
            </div>

            <h1 className="ep-title">Something went wrong</h1>
            <p className="ep-body">
              An unexpected error occurred. Try reloading the page — if the problem
              persists, return to the home page.
            </p>

            <div className="ep-actions">
              <button className="lp-submit ep-btn-reload" onClick={() => window.location.reload()}>
                Reload page
              </button>
              <a className="ep-btn-home" href="/home">
                Go to home
              </a>
            </div>

          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
